import * as React from "react";
function SvgGrid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M0 0h6v6H0zM0 13h6v6H0zM13 0h6v6h-6zM26 0h6v6h-6zM26 13h6v6h-6zM13 13h6v6h-6zM0 26h6v6H0zM26 26h6v6h-6zM13 26h6v6h-6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGrid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
